import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import { BoxButton, MainHeading} from '../../StyledComponents';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import SentimentSettings from './SentimentSettings';
/**
* Colors
*/
const themeColors = ['#00ae89', '#df5c5e', '#ff6000', '#2575bb', '#7b4172', '#e7969c', '#a55094', '#843c39'];


/**
* styled components
*/
const TagBoxContainer = styled.div`
  h2 {
    text-transform: uppercase;

  }
`;

const Tags = styled.div``;

const Tag = styled.span`
  margin-right: 10px !important;
  border-radius: 10px !important;
  padding: 5px 8px !important;
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: 500;
`;


const modalStyleOpenDialog = {
  maxWidth: '700px',
  overflowY: 'scroll'
}

const EditButton = styled(BoxButton) `
  min-width:30px;
  float:right;
`;


/**
* Class TagBox
*/
class SentimentReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editDialogOpen: false,
    };
  }

  renderTags(tags, colored) {
    return (
      <Tags>
      {
        _.map(tags, (tag, index) => {
          return(
            <Tag key={`boxtag-${tag}-${index}`} className="tiny-font-size report-tag" style={colored ? {color: themeColors[index]} : {}}>{tag}</Tag>
          );
        })
      }
      </Tags>
    )
  }

  handleCloseEditDialog = () => {
    this.setState({editDialogOpen: false});
  };

  renderTags = (type) => {
    let sentimentSettings = (this.props.user && this.props.user.userProfile && this.props.user.userProfile.sentimentSettings) ? this.props.user.userProfile.sentimentSettings : {};
    const positive = sentimentSettings.positive || [];
    const negative = sentimentSettings.negative || [];
    let all = [];
    all.push(...negative);
    all.push(...positive);
    all = all.map(v => v.toLowerCase());
    let tags = this.props.data && this.props.data.variableData && this.props.data.variableData.sentimentData;
    let tagWords = tags ? tags.map(function(tag,i) {
      return tag["word"];
    }):[];
    tagWords = tagWords.map(v => v.toLowerCase());

    let tagsOut = [];

    switch (type) {
      case 'observed':
        //tagsOut = tagWords.map(function(item,i) {
        tagWords.forEach(function(item,i) {
          if (all.indexOf(item) > -1) {
            tagWords.push(<Tag className="tiny-font-size report-tag" key={i}>{item}</Tag>);
          }
        });
        if (!tagsOut.length) {
          tagsOut.push(<span>No data available</span>);
        }
        break;

      case 'missing':
        positive.forEach(function(item,i) {
          if (!tagWords.indexOf(item) > -1) {
            tagsOut.push(<Tag className="tiny-font-size report-tag" key={i}>{item}</Tag>);
          }
        });
        if (!tagsOut.length) {
          tagsOut.push(<span>No data available</span>);
        }
        break;
      default:
        break;
    }
    return <Tags>{tagsOut}</Tags>;
  }

  render() {
    const editDialogActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleCloseEditDialog}
        key="cancel"
      />
    ];

    return(
      <TagBoxContainer>
      <EditButton
        onClick={() => this.setState({editDialogOpen: !this.state.editDialogOpen})}
        className="margin-right hidden-xs"
      >
          <span>&#9776;</span>
      </EditButton>

        <MainHeading className="big-font-size m-b">Keywords and tags</MainHeading>

        <h2 className="normal-font-size">Observed:</h2>
        {this.renderTags('observed')}

        <h2 className="normal-font-size">Missing:</h2>
        {this.renderTags('missing')}

        <Dialog
          title="Sentiment"
          modal={false}
          open={this.state.editDialogOpen}
          onRequestClose={this.handleCloseEditDialog}
          contentStyle={modalStyleOpenDialog}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={true}
        >
          <SentimentSettings/>
          <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>
            {editDialogActions}
          </div>
        </Dialog>
      </TagBoxContainer>
    );
  }
}


function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        data: state.data,
        user: state.user
    };
}

export default connect(mapStateToProps)(SentimentReport);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/SentimentReport.js